export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_OGRE_complete_7.77c491ab.jpg";